import {
  type Algorithm,
  type PromiseFactory,
  type PromiseHandler,
  type SetCertificatePromiseOptions,
} from "qz-tray";

import { qz } from "./client";

export type BootstrapQZOptions = {
  /** Optional extra flags forwarded to `qz.security.setCertificatePromise`. */
  certificateOptions?: SetCertificatePromiseOptions;
  /**
   * Returns the client's signed certificate in PEM form. Must be installed
   * before any connection attempt. See qz-tray docs for `setCertificatePromise`.
   */
  getCertificate: PromiseHandler;
  /**
   * Called by qz-tray to sign a server-provided nonce. Return the signature
   * as a string. A plain `(data) => Promise<string>` works too; the library
   * wraps it into a promise factory.
   */
  sign: ((dataToSign: string) => Promise<string>) | PromiseFactory;
  /** Signature algorithm for `setSignatureAlgorithm`. Defaults to SHA-512. */
  signatureAlgorithm?: Algorithm;
};

let bootstrapped = false;

/**
 * One-time wiring of the qz-tray security pipeline. Idempotent: repeat calls
 * after the first are ignored so HMR / route remounts don't re-install the
 * callbacks.
 */
export const bootstrapQZ = (options: BootstrapQZOptions) => {
  if (bootstrapped) return;

  bootstrapped = true;

  qz.security.setSignatureAlgorithm(options.signatureAlgorithm ?? "SHA512");
  qz.security.setCertificatePromise(
    options.getCertificate,
    options.certificateOptions,
  );
  qz.security.setSignaturePromise(options.sign);
};
